import React from 'react'
import PropTypes from 'prop-types'
import { Container } from 'react-bootstrap'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { CommonForm } from 'src/views/components'
import {
  addressContainer,
  tokenExContainer,
  paymetricContainer,
  storeContainer,
  checkoutContainer,
  cartContainer,
  accountsAddressContainer,
  subscriptionContainer,
  customerContainer,
} from 'src/models'
import { renderFormInput } from './formInput'
import { schema } from './validationSchema'
import { paymetricIframe } from 'src/views/components/PaymetricIframe'
import {
  isExpressCheckout,
  enableBillingAddressRequired,
  convertToBoolean,
} from 'src/utils'
import { APPConfig } from 'config/appConfig'
import './styles.scss'

@observer
class PaymentForm extends React.Component {
  @observable shouldRenderAddressForm = false
  @observable addPaymentToProfile = true
  @observable addressChangeFlag = {}
  @observable country = ''
  @observable cardExipry = ''
  @observable cardFirstname = ''
  @observable cardnumber = ''
  @observable expiryFlag = true
  @observable firstNameFlag = true
  @observable cardnumberFlag = true
  @observable savePaymentCheckboxFlag = true
  @observable addressCheckboxFlag = true
  @observable defaultPaymentCheckbox = false
  @observable defaultPaymentCheckboxFlag = false
  @observable selectedCountry =
    this.props?.paymentData?.billingAddress?.country ||
    storeContainer.storeIDValue

  static defaultProps = {
    paymentData: [],
    isFromPayment: false,
    isFromEditPayment: false,
    includePaymetricCvv: true,
  }

  constructor(props) {
    super(props)
    const isBillingAddressRequired = enableBillingAddressRequired()
    this.shouldRenderAddressForm = isBillingAddressRequired
      ? props.isMultipleAdressActive ||
        (!props.isFromEditPayment && !this.hasDefaultAddress()) ||
        false
      : false
  }

  hasDefaultAddress = () => {
    const {
      isFromCheckout = false,
      isFromEditSubscription = false,
      billingAddress = {},
      editUpdateModalEnabled = false,
    } = this.props
    const accountAddress =
      accountsAddressContainer.addressData?.length > 0
        ? accountsAddressContainer.addressData
        : []
    const addressData =
      addressContainer.addressData?.length > 0
        ? addressContainer.addressData
        : accountAddress
    let defaultAddress = addressData?.some(
      address => address?.isDefault === true
    )
    let checkoutDeliveryAddress =
      cartContainer?.cartResponse?.deliveryDetails?.address || {}
    let isShippingAddressAvailable =
      checkoutDeliveryAddress &&
      Object.keys(checkoutDeliveryAddress) &&
      Object.keys(checkoutDeliveryAddress).length > 0
        ? true
        : defaultAddress
    let subscriptionShippingAddress =
      subscriptionContainer.subscriptionPreferenceResponse?.addresses || {}
    let isSubscriptionAddressAvailable =
      subscriptionShippingAddress &&
      Object.keys(subscriptionShippingAddress) &&
      Object.keys(subscriptionShippingAddress).length > 0
        ? true
        : defaultAddress
    let isBillingAddressAvailable =
      billingAddress &&
      Object.keys(billingAddress) &&
      Object.keys(billingAddress)?.length > 0
        ? true
        : defaultAddress

    let isAddressAvailable = editUpdateModalEnabled
      ? isBillingAddressAvailable
      : isFromCheckout
        ? isShippingAddressAvailable
        : isFromEditSubscription
          ? isSubscriptionAddressAvailable
          : defaultAddress
    return isAddressAvailable
  }

  componentDidMount() {
    const { billingAddressType = '' } = this.props
    const enableDirectPaymetricAndAccertifyIntegration = convertToBoolean(
      APPConfig?.getAppConfig()?.enableDirectPaymetricAndAccertifyIntegration
    )
    const isCheckoutFlow = billingAddressType === 'checkout'
    const includePaymetricCvv = this.props.includePaymetricCvv !== false
    if (!customerContainer.isSignOutClicked) {
      if (enableDirectPaymetricAndAccertifyIntegration) {
        paymetricContainer.cleanup({ removeScript: false })
        paymetricContainer.loadPaymetricIframe({
          includeCvv: includePaymetricCvv,
          iframeText: paymetricIframe.getIframeText(
            this.props.editUpdateModalEnabled
          ),
          isCheckoutFlow,
          isFromEdit:
            this.props.isFromEditPayment ||
            this.props.isFromEditSubscription ||
            this.props.editUpdateModalEnabled,
        })
      } else {
        tokenExContainer.loadTokenExIframe()
      }
    }
    if (!enableDirectPaymetricAndAccertifyIntegration) {
      tokenExContainer.tokenExValidData = false
    } else if (!paymetricContainer.paymetricValidData?.isValid) {
      // Only reset if card has not already been successfully tokenized.
      // Preserves paymetricValidData.isValid = true across iframe reloads
      // so Submit Order can detect that the card is ready.
      paymetricContainer.paymetricValidData = false
    }
    const { isFromEditPayment = false, paymentData = {} } = this.props
    checkoutContainer.paymentBillingSameAsShippingFlag = isFromEditPayment
      ? this.addressCheckboxFlag
      : this.hasDefaultAddress()
    if (isExpressCheckout() && !customerContainer?.isRegisterUser) {
      checkoutContainer.paymentBillingSameAsShippingFlag = true
    }
    let country =
      paymentData?.billingAddress?.country ||
      storeContainer.defaultShippingRegion
    checkoutContainer.selectedMarket =
      country?.toLowerCase() === 'canada' ? 'CA' : country
  }

  componentWillUnmount() {
    const enableDirectPaymetricAndAccertifyIntegration = convertToBoolean(
      APPConfig?.getAppConfig()?.enableDirectPaymetricAndAccertifyIntegration
    )
    if (enableDirectPaymetricAndAccertifyIntegration) {
      paymetricContainer.cleanup({ removeScript: false })
    }
  }

  inputToValue = event => {
    this.expiryFlag = false
    if (event?.target?.value > 1 && event?.target?.value?.length > 2) {
      this.cardExipry = `${event.target.value.slice(
        0,
        2
      )}/${event.target.value.slice(2, 4)}`
    } else if (event?.target?.value?.length <= 3) {
      if (event?.target?.value > 1 && event?.target?.value?.length == 1) {
        this.cardExipry = `0${event.target.value.slice(
          0,
          2
        )}/${event.target.value.slice(2, 4)}`
      } else this.cardExipry = event.target.value.slice(0, 2)
    } else this.cardExipry = event.target.value
  }

  inputFirstname = event => {
    this.firstNameFlag = false
    this.cardFirstname = event.target.value
  }

  handleSubmit = formData => {
    const { onSubmit = function () {} } = this.props
    if (typeof onSubmit === 'function') {
      onSubmit(formData)
    }
  }

  handleAddressChanges = event => {
    this.addressChangeFlag = {
      [event.target.name]: true,
    }
    this.country = event.target.value
    checkoutContainer.selectedMarket = event.target.value
  }

  handleAddressCheckbox = () => {
    this.shouldRenderAddressForm = !this.shouldRenderAddressForm
    this.addressCheckboxFlag = !this.addressCheckboxFlag
    checkoutContainer.paymentBillingSameAsShippingFlag =
      !checkoutContainer.paymentBillingSameAsShippingFlag
  }

  handleAddPaymentCheckbox = () => {
    this.addPaymentToProfile = !this.addPaymentToProfile
    this.savePaymentCheckboxFlag = !this.savePaymentCheckboxFlag
  }
  handleDefaultPaymentCheckbox = () => {
    this.defaultPaymentCheckbox = !this.defaultPaymentCheckbox
    this.defaultPaymentCheckboxFlag = !this.defaultPaymentCheckboxFlag
  }

  render() {
    const {
      isFromEditPayment = false,
      className = '',
      paymentData = {},
      refId = '',
      isFromCheckout = false,
      billingAddress = {},
    } = this.props
    const addressToDisplay = paymentData?.billingAddress || {}
    const {
      firstName = '',
      lastName = '',
      addressLine1 = '',
      addressLine2 = '',
      city = '',
      state = '',
      country = '',
    } = addressToDisplay
    const hasSubscriptionProduct = cartContainer.hasSubscriptionProduct()
    const enableDirectPaymetricAndAccertifyIntegration = convertToBoolean(
      APPConfig?.getAppConfig()?.enableDirectPaymetricAndAccertifyIntegration
    )
    const isPaymetricNoCvvMode =
      enableDirectPaymetricAndAccertifyIntegration &&
      this.props.includePaymetricCvv === false
    const constructStyleForPaymentForm = {
      formColumnClassName: 'pb-lg-3',
      formClassName: isExpressCheckout() ? 'expressCheckoutForm' : '',
      formRowClassName: '',
    }
    return (
      <Container
        className={`form-container ${className} ${
          enableDirectPaymetricAndAccertifyIntegration
            ? 'paymetric-enabled-mode'
            : ''
        } ${
          isPaymetricNoCvvMode ? 'paymetric-no-cvv-mode' : ''
        } ${isExpressCheckout() ? 'p-2' : 'px-0 bg-white'}`}
        data-testid={
          isFromEditPayment
            ? 'qa-edit-payment-container'
            : 'qa-add-payment-container'
        }>
        <CommonForm
          schema={schema({
            shouldRenderAddressForm: this.shouldRenderAddressForm,
            countryValue: this.selectedCountry,
            hasSubscriptionProduct,
            ...this.props,
          })}
          formTypeJson={renderFormInput({
            handleAddressCheckbox: this.handleAddressCheckbox,
            handleAddPaymentCheckbox: this.handleAddPaymentCheckbox,
            shouldRenderAddressForm: this.shouldRenderAddressForm,
            formatFunction: this.cardExipry,
            inputToValue: this.inputToValue,
            expiryFlag: this.expiryFlag,
            addressCheckboxFlag: this.addressCheckboxFlag,
            savePaymentCheckboxFlag: this.savePaymentCheckboxFlag,
            handleDefaultPaymentCheckbox: this.handleDefaultPaymentCheckbox,
            defaultPaymentCheckbox: this.defaultPaymentCheckbox,
            defaultPaymentCheckboxFlag: this.defaultPaymentCheckboxFlag,
            cardnumber: this.cardnumber,
            addressChangeFlag: this.addressChangeFlag,
            cardnumberFlag: this.cardnumberFlag,
            cardFirstname: this.cardFirstname,
            addressValues: this.addressValues,
            firstNameFlag: this.firstNameFlag,
            inputFirstname: this.inputFirstname,
            handlePaymentAddressChanges: this.handleAddressChanges,
            isFromCheckout: isFromCheckout || false,
            countryVal: this.country,
            selectedBillingAddress: billingAddress,
            hideDefaultSubPaymentCheckbox:
              this.props.hideDefaultSubPaymentCheckbox || false,
            hasSubscriptionProduct,
            isToHideLabel: true,
            ...this.props,
          })}
          reference={refId}
          hasInlineSubmitButton={true}
          id="payment-form"
          onSubmit={formData => this.handleSubmit(formData)}
          classNameValue={constructStyleForPaymentForm}
        />

        {this.shouldRenderAddressForm == false && (
          <div data-testid="qa-default-address" className="ml-2">
            {addressToDisplay !== '' && (
              <div id="shipping-display">
                <div className="d-flex">
                  <p className="shipping-line-1">{firstName}</p>
                  <p className="shipping-line-1">{lastName}</p>
                </div>
                <p>{addressLine1}</p>
                <p>{addressLine2}</p>
                <p>{city}</p>
                <p>{state}</p>
                <p>{country}</p>
              </div>
            )}
          </div>
        )}
      </Container>
    )
  }
}

PaymentForm.propTypes = {
  isFromCheckout: PropTypes.bool,
  billingAddressType: PropTypes.string,
  includePaymetricCvv: PropTypes.bool,
}

export default PaymentForm
export { PaymentForm }
